export default __webpack_public_path__ + "static/media/mode_24px_outlined.1bb6f8e5.svg";